import React, { useEffect } from 'react'
import context from '@/context'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/systemRsaKeys'
import { BsrsGrid, Column, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import { Form, Row, Col, Alert } from 'reactstrap'
import Resx from '@/components/Resx'
import { useLocalization } from '@/hooks/localization'
import { Main, MainTop, MainTopTitle, MainBody } from '@/components/Layout'
import { Button } from '@/components/button'

const SystemRsaKeysManagement = ({ hasValidKey, systemRsaKeys, generateSystemRsaKeys }) => {
  useEffect(() => {
    hasValidKey()
  }, [hasValidKey])
  const { localize } = useLocalization()

  const { hasValidKey: hasKey, fetching, gridComponentKey } = systemRsaKeys
  return (
    <Main>
      <MainTop>
        <MainTopTitle><Resx name='Security.SystemRsaKeysTitle' /></MainTopTitle>
      </MainTop>
      <MainBody>
        <Form>
          {!hasKey && !fetching && <Row><Col><Alert><Resx name='Security.NoValidSystemRsaKeysWarning' /></Alert></Col></Row>}
          <Row>
            <Col>
              <Button
                onClick={generateSystemRsaKeys}
                confirmText={hasKey ? 'Security.ConfirmGenerateSystemRsaMessage' : null}
                color='primary'
                disabled={fetching}
                className='' icon={fetching ? 'bx-loader bx-spin' : 'chip'}> <span><Resx name='Security.GenerateButton' /></span>
              </Button>
            </Col>
          </Row>
          <Row><Col>&nbsp;</Col></Row>
          <Row>
            <Col>
              <BsrsGrid
                dataSource={context.api.cryptoService.getAllSystemRsaKeys}
                defaultSort={[{ field: 'creationTime', dir: 'desc' }]}
                lastReloadedAt={gridComponentKey}>
                <Column field='id' title={localize('Common.Id')} filter='numeric' />
                <Column field='creationTime' title={localize('Security.CreatedAt')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
                <Column field='invalidatedAt' title={localize('Security.InvalidatedAt')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
              </BsrsGrid>
            </Col>
          </Row>
        </Form>
      </MainBody>
    </Main>
  )
}

function mapStateToProps (state) {
  return {
    systemRsaKeys: state.systemRsaKeys
  }
}

const mapDispatchToProps = {
  hasValidKey: actionCreators.hasValidKey,
  generateSystemRsaKeys: actionCreators.generateSystemRsaKeys
}

export default connect(mapStateToProps, mapDispatchToProps)(SystemRsaKeysManagement)



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/systemRsaKeys/index.js